module.exports = __webpack_public_path__ + "img/element.66a51cb4.png";